import { useEffect, useRef } from 'react'
import useWindowFocus from './useWindowFocus'

type UseUnviewAllOnLeaveParams = {
  relavantPages: boolean
  onUnviewAll: () => Promise<any> | void
}

const useUnviewAllOnLeave = ({
  relavantPages,
  onUnviewAll,
}: UseUnviewAllOnLeaveParams) => {
  const isFocus = useWindowFocus()

  const prevFocusRef = useRef<boolean>(isFocus)
  const prevRelevantRef = useRef<boolean>(!!relavantPages)
  const requestLockedRef = useRef<boolean>(false)
  const mountedRef = useRef<boolean>(false)

  useEffect(() => {
    const currentRelevant = !!relavantPages
    const prevFocus = prevFocusRef.current
    const prevRelevant = prevRelevantRef.current

    if (!mountedRef.current) {
      mountedRef.current = true
      prevFocusRef.current = isFocus
      prevRelevantRef.current = currentRelevant
      return
    }

    const leftRelevantPage = prevRelevant && !currentRelevant
    const lostFocus = prevFocus && !isFocus
    const shouldTrigger = prevRelevant && (leftRelevantPage || lostFocus)

    if (shouldTrigger && !requestLockedRef.current) {
      requestLockedRef.current = true

      Promise.resolve(onUnviewAll()).catch((error) => {
        console.error('onUnviewAll error:', error)
        requestLockedRef.current = false
      })
    }

    if (currentRelevant && isFocus) {
      requestLockedRef.current = false
    }

    prevFocusRef.current = isFocus
    prevRelevantRef.current = currentRelevant
  }, [isFocus, relavantPages, onUnviewAll])

  return { isFocus }
}

export default useUnviewAllOnLeave